// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--BgQ0C"};